import React from "react";
import { toAbsoluteUrl } from "src/resources/helpers";

interface MarketplaceCellProps {
  marketplaceCode: string;
  accountId: string;
  dataAccount: { id: string; name: string }[];
}

const MarketplaceCell: React.FC<MarketplaceCellProps> = ({
  marketplaceCode,
  accountId,
  dataAccount,
}) => {
  const marketplaceName = dataAccount.find(
    (item) => item.id === accountId
  )?.name;

  return (
    <div className="w-100 m-0 p-0 d-flex flex-row align-items-center justify-content-center">
      <img
        loading="lazy"
        className="p-0 m-0 align-self-center justify-content-center me-2"
        src={toAbsoluteUrl(
          `/media/logos/marketplace/${marketplaceCode.toLowerCase()}.png`
        )}
        alt={marketplaceCode}
        onError={(e) => {
          e.currentTarget.src = toAbsoluteUrl(
            `/media/images/dummy-image-square.jpg`
          );
        }}
        style={{
          objectFit: "cover",
          objectPosition: "start",
          width: "auto",
          height: "20px",
          maxWidth: "20px",
        }}
      />

      <p className="w-100 h-fit fw-bolder text-start p-0 m-0">
        {marketplaceName ?? " "}
      </p>
    </div>
  );
};

export default MarketplaceCell;
